document.addEventListener('DOMContentLoaded', () => {
  const app = document.querySelector('.yd-app');
  if (!app) return;
  const clientCopy = JSON.parse(app.querySelector('[data-yd-client-copy]')?.textContent || '{}');
  const menu = app.querySelector('[data-yd-menu]');
  const nav = app.querySelector('[data-yd-nav]');
  if (menu && nav) {
    const closeMenu = (restoreFocus = false) => {
      menu.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('yd-menu-open');
      if (restoreFocus) menu.focus();
    };
    menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeMenu();
      } else {
        menu.setAttribute('aria-expanded', 'true');
        nav.classList.add('is-open');
        document.documentElement.classList.add('yd-menu-open');
      }
    });
    nav.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') closeMenu(true);
    });
  }

  const portfolioAltByFile = {
    '80A0148_8d733517-d61f-47d0-ab0f-18ab130a90de.jpg': 'プロフィールポートレート',
    'e8843e22994e5c133ee1e659006ff078.jpg': 'プロフィールポートレート',
  };
  app.querySelectorAll('img:not([alt])').forEach((image) => {
    const filename = Object.keys(portfolioAltByFile).find((name) => image.currentSrc.includes(name) || image.src.includes(name));
    image.alt = filename ? (clientCopy.portraitAlt || portfolioAltByFile[filename]) : '';
  });

  const noteFeed = app.querySelector('[data-note-feed]');
  if (noteFeed) {
    const rssUrl = noteFeed.dataset.noteRss;
    const featuredUrl = noteFeed.dataset.featuredUrl;
    const maxItems = Math.min(Math.max(Number(noteFeed.dataset.maxItems) || 6, 3), 6);
    const cacheKey = 'yd-note-feed-v2';
    const cacheLifetime = 30 * 60 * 1000;
    const knownThumbnails = {
      'https://note.com/yanodaisuke/n/nb1ccc48a220c': 'https://assets.st-note.com/production/uploads/images/319192725/rectangle_large_type_2_904267cea8c49b5a562bf01b33edff9b.jpeg',
      'https://note.com/yanodaisuke/n/nb12430f6f145': 'https://assets.st-note.com/production/uploads/images/319192523/rectangle_large_type_2_458d2863a39f6f972fd079e27b1339f9.jpeg',
      'https://note.com/yanodaisuke/n/nceac952bdfd8': 'https://assets.st-note.com/production/uploads/images/319160070/rectangle_large_type_2_07f4f406f269d7208b0e671768d368b0.jpeg',
      'https://note.com/yanodaisuke/n/nfd7b0dce0c0b': 'https://assets.st-note.com/production/uploads/images/319159693/rectangle_large_type_2_f23951e7350a550c3c7a29d1e9cadec5.jpeg',
      'https://note.com/yanodaisuke/n/nd90974d2d48e': 'https://assets.st-note.com/production/uploads/images/319159278/rectangle_large_type_2_51c9d767a12ff8cf451f0bc0c3536638.jpeg',
      'https://note.com/yanodaisuke/n/n22c7588362e6': 'https://assets.st-note.com/production/uploads/images/319158550/rectangle_large_type_2_8635bb2b4c429d20b6a4d3388ff84319.jpeg',
    };
    const normalizeUrl = (value, allowedHost) => {
      try {
        const url = new URL(value);
        if (url.protocol !== 'https:' || !allowedHost(url.hostname)) return '';
        return url.href;
      } catch (_error) {
        return '';
      }
    };
    const getExcerpt = (html) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      documentFragment.querySelectorAll('a').forEach((link) => link.remove());
      const paragraphs = [...documentFragment.querySelectorAll('p')]
        .map((paragraph) => paragraph.textContent.replace(/\s+/g, ' ').trim())
        .filter(Boolean);
      const text = (paragraphs.length ? paragraphs.slice(0, 2).join(' ') : documentFragment.body.textContent)
        .replace(/\s+/g, ' ')
        .trim();
      const characters = Array.from(text);
      return characters.length > 110 ? `${characters.slice(0, 110).join('')}…` : text;
    };
    const getDateParts = (value) => {
      const normalizedValue = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)
        ? `${value.replace(' ', 'T')}Z`
        : value;
      const date = new Date(normalizedValue);
      if (Number.isNaN(date.getTime())) return null;
      const displayParts = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'Asia/Tokyo',
      }).formatToParts(date);
      const display = ['day', 'month', 'year']
        .map((type) => displayParts.find((part) => part.type === type)?.value || '')
        .join(' ')
        .toUpperCase();
      const datetime = new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'Asia/Tokyo',
      }).format(date);
      return { display, datetime };
    };
    const imageUrlAtWidth = (value, width) => {
      const source = normalizeUrl(value, (host) => host === 'assets.st-note.com');
      if (!source) return '';
      const url = new URL(source);
      url.searchParams.set('width', String(width));
      url.searchParams.set('quality', '85');
      url.searchParams.set('fit', 'bounds');
      return url.href;
    };
    const renderFeed = (feed) => {
      if (feed?.status !== 'ok' || !Array.isArray(feed.items)) return false;
      const articles = feed.items.map((item) => {
        const rawTitle = String(item.title || '').trim();
        const numberMatch = rawTitle.match(/[＃#]\s*(\d+)/);
        const sourceTitle = rawTitle.replace(/^写真になる前の話\s*[＃#]\s*\d+\s*[｜|]\s*/, '').trim();
        const link = normalizeUrl(String(item.link || ''), (host) => host === 'note.com');
        const localizedArticle = clientCopy.articles?.[link];
        const title = localizedArticle?.title || sourceTitle;
        const knownThumbnail = knownThumbnails[link] || '';
        const thumbnail = knownThumbnail
          ? imageUrlAtWidth(knownThumbnail, 1280)
          : `https://api.microlink.io/?url=${encodeURIComponent(link)}&embed=image.url`;
        const thumbnailSmall = knownThumbnail ? imageUrlAtWidth(knownThumbnail, 640) : thumbnail;
        const excerpt = clientCopy.language === 'en' ? clientCopy.noteOriginal : getExcerpt(String(item.description || item.content || ''));
        const date = getDateParts(String(item.pubDate || ''));
        return { title, number: numberMatch?.[1] || '', link, thumbnail, thumbnailSmall, excerpt, date };
      }).filter((article) => (
        article.link &&
        article.link !== featuredUrl &&
        article.title &&
        article.thumbnail &&
        article.excerpt &&
        article.date
      )).slice(0, maxItems);

      if (articles.length < 3) return false;
      const fragment = document.createDocumentFragment();
      articles.forEach((article) => {
        const item = document.createElement('article');
        item.className = 'yd-journal-item yd-reveal is-visible';
        const link = document.createElement('a');
        link.href = article.link;
        link.target = '_blank';
        link.rel = 'noopener';

        const image = document.createElement('img');
        image.src = article.thumbnail;
        image.srcset = `${article.thumbnailSmall} 640w, ${article.thumbnail} 1280w`;
        image.sizes = '(max-width: 980px) calc(100vw - 44px), 42vw';
        image.alt = article.number ? `${clientCopy.journalTitle} ${article.number} — ${article.title}` : article.title;
        image.width = 1280;
        image.height = 670;
        image.loading = 'lazy';
        image.decoding = 'async';

        const meta = document.createElement('span');
        meta.className = 'yd-journal-item__meta';
        const time = document.createElement('time');
        time.dateTime = article.date.datetime;
        time.textContent = article.date.display;
        const essay = document.createElement('span');
        essay.textContent = article.number ? `ESSAY ${article.number}` : 'ESSAY';
        meta.append(time, essay);

        const heading = document.createElement('h3');
        heading.textContent = article.title;
        if (clientCopy.language === 'en' && !clientCopy.articles?.[article.link]) heading.lang = 'ja';
        const excerpt = document.createElement('p');
        excerpt.textContent = article.excerpt;
        const readMore = document.createElement('span');
        readMore.className = 'yd-text-link';
        readMore.textContent = 'Read on note ▸';
        link.append(image, meta, heading, excerpt, readMore);
        item.append(link);
        fragment.append(item);
      });
      noteFeed.replaceChildren(fragment);
      return true;
    };

    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached?.feed && Date.now() - cached.savedAt < cacheLifetime) renderFeed(cached.feed);
    } catch (_error) {
      localStorage.removeItem(cacheKey);
    }

    if (rssUrl) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      const feedUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}`;
      fetch(feedUrl, { credentials: 'omit', signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`Feed request failed: ${response.status}`);
          return response.json();
        })
        .then((feed) => {
          if (!renderFeed(feed)) throw new Error('Feed response could not be rendered');
          try {
            localStorage.setItem(cacheKey, JSON.stringify({ feed, savedAt: Date.now() }));
          } catch (_error) {
            // The live feed is already rendered; storage is only a performance enhancement.
          }
        })
        .catch((error) => {
          // Keep the server-rendered article list as a stable fallback.
          console.warn('[JOURNAL] The note feed could not be refreshed; showing the saved article list.', error);
        })
        .finally(() => window.clearTimeout(timeout));
    }
  }

  const workImageReplacements = {
    'いけばなの所作': {
      src: 'https://cdn.shopify.com/s/files/1/0705/7122/9277/files/d216688fcb2355e51c1a2583c889ab16.jpg?v=1791162197',
      width: 3511,
      height: 5267,
      alt: '光の差し込む和室で花を生ける人の所作',
    },
    '祈り': {
      src: 'https://cdn.shopify.com/s/files/1/0705/7122/9277/files/bbc8a10e4d22d8b0bd0731e3c20e5467.jpg?v=1791162196',
      width: 3648,
      height: 5472,
      alt: '目を閉じて祈る白い人物彫刻',
    },
    '寄り添いあって': {
      src: 'https://cdn.shopify.com/s/files/1/0705/7122/9277/files/651bc26607b3807b4afe793a39c0357d.jpg?v=1791162199',
      width: 3648,
      height: 5472,
      alt: '霧の草原で寄り添う三頭の馬',
    },
  };

  const portfolioGrid = app.querySelector('#yd-existing-work .yano-home-media-grid__inner');
  if (portfolioGrid) {
    if (!portfolioGrid.querySelector('[data-work-key="イシバシ ユウコ氏"], [data-title="イシバシ ユウコ氏"]')) {
      const featuredPortrait = document.createElement('article');
      featuredPortrait.className = 'yano-home-media-grid__item';
      const portraitTemplate = app.querySelector('[data-yd-featured-portrait]');
      if (portraitTemplate) featuredPortrait.appendChild(portraitTemplate.content.cloneNode(true));
      portfolioGrid.appendChild(featuredPortrait);

      const featuredCard = featuredPortrait.querySelector('.yano-home-media-grid__card');
      featuredCard?.addEventListener('click', () => {
        const lightbox = document.querySelector('.yano-home-media-grid__lightbox');
        const lightboxImage = lightbox?.querySelector('.yano-home-media-grid__lightbox-inner > img');
        const lightboxVideo = lightbox?.querySelector('.yano-home-media-grid__video');
        const lightboxIframe = lightbox?.querySelector('.yano-home-media-grid__iframe');
        const lightboxCategory = lightbox?.querySelector('.yano-home-media-grid__caption p');
        const lightboxTitle = lightbox?.querySelector('.yano-home-media-grid__caption h2');
        const lightboxDescription = lightbox?.querySelector('.yano-home-media-grid__caption span');
        const image = featuredCard.querySelector('img');
        if (!lightbox || !lightboxImage || !image) return;

        lightbox.classList.remove('is-video', 'is-youtube');
        if (lightboxVideo) {
          lightboxVideo.pause();
          lightboxVideo.removeAttribute('src');
          lightboxVideo.removeAttribute('poster');
        }
        if (lightboxIframe) lightboxIframe.src = '';
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        if (lightboxCategory) lightboxCategory.textContent = featuredCard.dataset.category || '';
        if (lightboxTitle) lightboxTitle.textContent = featuredCard.dataset.title || '';
        if (lightboxDescription) lightboxDescription.textContent = featuredCard.dataset.description || '';
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      });
    }

    portfolioGrid.querySelectorAll('.yano-home-media-grid__card').forEach((card) => {
      const workKey = card.dataset.workKey || card.dataset.title;
      const replacement = workImageReplacements[workKey];
      const image = card.querySelector('img');
      if (!replacement || !image) return;
      const separator = replacement.src.includes('?') ? '&' : '?';
      image.src = `${replacement.src}${separator}width=1600`;
      image.srcset = [480, 800, 1200, 1600]
        .map((width) => `${replacement.src}${separator}width=${width} ${width}w`)
        .join(', ');
      image.sizes = '(max-width: 749px) calc(100vw - 44px), (max-width: 980px) 48vw, 42vw';
      image.width = replacement.width;
      image.height = replacement.height;
      image.alt = clientCopy.imageAlts?.[workKey] || replacement.alt;
    });

    portfolioGrid.querySelectorAll('img:not([srcset])').forEach((image) => {
      const source = image.getAttribute('src');
      if (!source || !source.includes('cdn.shopify.com/s/files/')) return;
      const separator = source.includes('?') ? '&' : '?';
      image.srcset = [480, 800, 1200, 1600]
        .map((width) => `${source}${separator}width=${width} ${width}w`)
        .join(', ');
      image.sizes = '(max-width: 749px) calc(100vw - 44px), (max-width: 980px) 48vw, 42vw';
    });
    const priorityTitles = [
      'イシバシ ユウコ氏',
      'いけばなの所作',
      '解体前の建物記録',
      'The Artist’s Voice',
      '時の流れ',
      '宇宙の甘木染め',
      '渡邉 敬子氏',
      '蓮明寺 花祭りの記録',
      'はる風の舞',
      '鈴木氏',
      '紅葉の五十鈴川',
      '竹を編む',
      '祈り',
      '藤村 都寿氏',
      '個展の風景',
      '公開いけこみの記録',
      '静寂の紫陽花',
      '波動スピーカー体験イベントの記録',
      '寄り添いあって',
    ];
    const priority = new Map(priorityTitles.map((title, index) => [title, index]));
    const originalItems = [...portfolioGrid.querySelectorAll('.yano-home-media-grid__item')];
    const editorialItems = [...originalItems].sort((first, second) => {
      const firstTitle = first.querySelector('.yano-home-media-grid__card')?.dataset.workKey || first.querySelector('.yano-home-media-grid__card')?.dataset.title || '';
      const secondTitle = second.querySelector('.yano-home-media-grid__card')?.dataset.workKey || second.querySelector('.yano-home-media-grid__card')?.dataset.title || '';
      const firstRank = priority.has(firstTitle) ? priority.get(firstTitle) : priorityTitles.length + originalItems.indexOf(first);
      const secondRank = priority.has(secondTitle) ? priority.get(secondTitle) : priorityTitles.length + originalItems.indexOf(second);
      return firstRank - secondRank;
    });
    const stillPositions = ['yd-work-pos-a', 'yd-work-pos-b', 'yd-work-pos-d', 'yd-work-pos-e', 'yd-work-pos-f'];
    let stillIndex = 0;

    editorialItems.forEach((item) => {
      const card = item.querySelector('.yano-home-media-grid__card');
      const image = card?.querySelector('img');
      const isMotion = card?.dataset.type === 'video';
      const positionClass = isMotion ? 'yd-work-pos-wide' : stillPositions[stillIndex++ % stillPositions.length];
      item.classList.add('yd-work-editorial-item', positionClass);
      if (isMotion) item.classList.add('yd-work-editorial-item--motion');

      const markImageShape = () => {
        if (!image?.naturalWidth || !image.naturalHeight) return;
        const ratio = image.naturalWidth / image.naturalHeight;
        const shape = ratio > 1.2 ? 'landscape' : ratio >= 0.78 ? 'square' : 'portrait';
        item.classList.add(`yd-work-shape--${shape}`);
      };
      if (image?.complete) markImageShape();
      else image?.addEventListener('load', markImageShape, { once: true });

      if (card) {
        const title = card.dataset.title || image?.alt || '作品';
        const category = card.dataset.category ? ` — ${card.dataset.category}` : '';
        card.setAttribute('aria-label', `${title}${category}${isMotion ? clientCopy.playFilm : clientCopy.viewWork}`);
        const workKey = card.dataset.workKey || title;
        const projectUrl = workKey === 'The Artist’s Voice'
          ? (app.dataset.ydArtProjectUrl || '/pages/projects#project-art-experiment')
          : workKey === '公開いけこみの記録'
            ? (app.dataset.ydIkebanaProjectUrl || '/pages/projects/rose-exhibition-public-ikebana-documentation')
            : workKey === 'いけばなの所作'
              ? app.dataset.ydRenmyojiProjectUrl
            : workKey === '宇宙の甘木染め'
              ? app.dataset.ydAmagiProjectUrl
            : '';
        if (projectUrl && !item.querySelector('.yd-work-project-link')) {
          const projectLink = document.createElement('a');
          projectLink.className = 'yd-text-link yd-work-project-link';
          projectLink.href = projectUrl;
          const linksWithinCurrentPage = projectLink.pathname === window.location.pathname && projectLink.hash === '#project-art-experiment';
          projectLink.textContent = linksWithinCurrentPage ? clientCopy.projectViewDown : clientCopy.projectView;
          item.appendChild(projectLink);
        }
      }
      portfolioGrid.appendChild(item);
    });
    portfolioGrid.classList.add('yd-work-editorial-grid');

  }

  // Text links use the same current-image registry as WORK, not its older saved image.
  app.querySelectorAll('#yd-commissions-selected-works .yd-commissions-examples [data-yd-home-work]').forEach((card) => {
    const replacement = workImageReplacements[card.dataset.workKey];
    if (!replacement) return;
    const separator = replacement.src.includes('?') ? '&' : '?';
    card.dataset.imageSrc = `${replacement.src}${separator}width=1600`;
    card.dataset.imageAlt = clientCopy.imageAlts?.[card.dataset.workKey] || replacement.alt;
  });

  // HOME and COMMISSIONS reuse WORK's server-rendered modal and handlers.
  const workTriggers = portfolioGrid || app.querySelector('#yd-selected-works, #yd-commissions-selected-works, #yd-portrait-selected-works');
  if (workTriggers) {
    // Keep the original media/open/close handlers, with focus and scroll containment.
    const workLightbox = document.querySelector('.yano-home-media-grid__lightbox');
    const workClose = workLightbox?.querySelector('.yano-home-media-grid__close');
    const workInner = workLightbox?.querySelector('.yano-home-media-grid__lightbox-inner');
    if (workLightbox && workClose && workInner) {
      workLightbox.classList.add('yd-work-lightbox');
      workLightbox.setAttribute('role', 'dialog');
      workLightbox.setAttribute('aria-modal', 'true');
      workLightbox.setAttribute('aria-label', clientCopy.dialogLabel);
      workInner.setAttribute('tabindex', '0');
      workInner.setAttribute('role', 'region');
      workInner.setAttribute('aria-label', clientCopy.dialogRegion);
      let workWasOpen = false;
      let workReturnFocus = null;
      const workCaption = workLightbox.querySelector('.yano-home-media-grid__caption');
      const renmyojiUrl = app.dataset.ydRenmyojiProjectUrl;
      let renmyojiLink = null;
      if (workCaption && renmyojiUrl) {
        renmyojiLink = document.createElement('a');
        renmyojiLink.className = 'yd-text-link yd-work-project-link';
        renmyojiLink.textContent = clientCopy.projectView;
        renmyojiLink.href = renmyojiUrl;
      }
      const amagiUrl = app.dataset.ydAmagiProjectUrl;
      let amagiLink = null;
      if (workCaption && amagiUrl) {
        amagiLink = document.createElement('a');
        amagiLink.className = 'yd-text-link yd-work-project-link';
        amagiLink.textContent = clientCopy.projectView;
        amagiLink.href = amagiUrl;
      }
      const appWasInert = app.inert;
      workTriggers.addEventListener('click', (event) => {
        const card = event.target.closest('.yano-home-media-grid__card, [data-yd-home-work]');
        if (card) {
          workReturnFocus = card;
          if (renmyojiLink) {
            if ((card.dataset.workKey || card.dataset.title) === 'いけばなの所作') workCaption.appendChild(renmyojiLink);
            else renmyojiLink.remove();
          }
          if (amagiLink) {
            if ((card.dataset.workKey || card.dataset.title) === '宇宙の甘木染め') workCaption.appendChild(amagiLink);
            else amagiLink.remove();
          }
        }
      }, true);
      new MutationObserver(() => {
        const isOpen = workLightbox.classList.contains('is-open');
        if (isOpen === workWasOpen) return;
        workWasOpen = isOpen;
        document.body.classList.toggle('yd-work-modal-open', isOpen);
        app.inert = isOpen || appWasInert;
        if (isOpen) {
          workInner.scrollTop = 0;
          workClose.focus({ preventScroll: true });
        } else if (workReturnFocus?.isConnected) {
          workReturnFocus.focus({ preventScroll: true });
        }
      }).observe(workLightbox, { attributes: true, attributeFilter: ['class'] });
      workInner.addEventListener('click', (event) => {
        if (event.target === workInner) workClose.click();
      });
      workLightbox.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...workLightbox.querySelectorAll('button, a[href], video[controls], iframe, [tabindex="0"]')]
          .filter((element) => !element.disabled && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();first?.focus();
        }
      });
    }
  }

  const reveals = app.querySelectorAll('.yd-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((item) => observer.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add('is-visible'));
  }
});
